import ArticlePage from "@/pages/article/ArticlePage";

export default function BestTshirtsStreetwear() {
  return <ArticlePage slug="best-tshirts-streetwear-vigorbuy-spreadsheet" />;
}